import { render, staticRenderFns } from "./senarai_projek.vue?vue&type=template&id=00456b0c"
import script from "./senarai_projek.vue?vue&type=script&lang=js"
export * from "./senarai_projek.vue?vue&type=script&lang=js"
import style0 from "./senarai_projek.vue?vue&type=style&index=0&id=00456b0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports